/* eslint-disable jsx-a11y/alt-text */
import "./ProductOverview.scss";
import screen1 from "../../../../../assets/sk2r/screen1.png";
import screen2 from "../../../../../assets/sk2r/screen2.png";
import pc from "../../../../LandingPage/Assets/Macbook.png";
import grid from "../../../../../assets/grid.png";
import pricingActions from "../../../redux/actions";

import example from "../../../../LandingPage/Assets/Group2.png";
import shoeroto from "../../../../../assets/shoe-roto.mp4";
import perk1 from "../../../../../assets/perk1.svg";
import perk2 from "../../../../../assets/perk2.svg";
import perk3 from "../../../../../assets/perk3.svg";
import perk4 from "../../../../../assets/perk4.svg";
import perk5 from "../../../../../assets/perk5.svg";
import colormap from "../../../../../assets/colormap-demo.jpg";
import { useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import { Button } from "antd";
import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

const ProductOverview = () => {
  const dispatch = useDispatch();
  const handlePioneerClick = () => {
    dispatch(pricingActions.pricingStateChanged("checkout"));
  };

  useEffect(() => {
    Aos.init({
      duration: 3000,
      delay: 200,
    });
  }, []);
  return (
    <div>
      <div className="row ">
        <div data-aos="fade-up" className="pioneer-container">
          <p>Be part of the future </p>
          <h1>
            Become a <span className="gradient">Pioneer</span>
          </h1>
          <p
            style={{
              color: "#F5F5F5",
              paddingLeft: "20%",
              paddingRight: "20%",
            }}
          >
            By becoming a Vizcom Pioneer you are helping accelerate the
            development of next generation creative tools that reimagine the way
            artists and designers create. This subscription provides a
            collection of perks.
          </p>
          <div className="row perks">
            <div className="col s12 m4 l4 " style={{ padding: "74px" }}>
              <img src={perk1} />
              <h1 style={{ fontSize: "18px" }}>Early access</h1>
              <p>
                Receive routine early access to features , discoveries and
                content before they launch to the public.
              </p>
            </div>
            <div className="col s12 m4 l4 " style={{ padding: "74px" }}>
              <img src={perk2} />
              <h1 style={{ fontSize: "18px" }}>Performance</h1>
              <p>
                Full advantage of the Vizcom web architecture and designed to
                get the best performance out of the web browser.
              </p>
            </div>
            <div className="col s12 m4 l4 " style={{ padding: "74px" }}>
              <img src={perk3} />
              <h1 style={{ fontSize: "18px" }}>Exclusive content</h1>
              <p>
                Access to exclusive discord channels and more where you can make
                feature requests and talk directly with the developers of
                Vizcom.
              </p>
            </div>
          </div>
        </div>
        <div
          className=" row sketchtorender"
          style={{
            paddingTop: "8rem",
            paddingBottom: "8rem",
            paddingRight: "5%",
            paddingLeft: "5%",
          }}
        >
          <div className=" col s12 m6 l6">
            <img src={screen1} style={{ width: "100%", padding: "5%" }} />
          </div>
          <div className=" col s12 m6 l6">
            <img
              src={screen2}
              style={{ maxWidth: "100%", paddingTop: "10%" }}
            />
            <h1>SketchtoRender </h1>
            <p>Automatically render your 2D sketches in seconds not hours.</p>
          </div>
        </div>
        <div
          className="row performance"
          style={{ paddingLeft: "10%", paddingRight: "10%" }}
        >
          <h1 style={{ textAlign: "center" }}>
            {" "}
            <span className="gradient">Performance</span> by design.
          </h1>
          <p
            style={{
              textAlign: "center",
              color: "#F5F5F5",
              paddingLeft: "20%",
              paddingRight: "20%",
            }}
          >
            SketchtoRender(S2R) renders fast. Really fast. Thanks to the power
            artificial intellegence, S2R is able to render as fast as you draw,
            paint or sketch. S2R is designed to keep you working at the pace you
            want.
          </p>
          <div className="col s12 m6 l6" style={{ paddingTop: "15%" }}>
            <video width="100%" height="auto" controls muted loop>
              <source src={shoeroto} type="video/mp4" />
            </video>
            <p></p>
          </div>
          <div
            className="col s12 m6 l6 ai-rendering"
            style={{ paddingTop: "15%" }}
          >
            <div>
              <img src={perk4} style={{ width: "40px" }} />
              <h1 style={{ fontSize: "18px" }}>Ai Rendering</h1>
              <p
                style={{
                  color: "#989898",
                  paddingRight: "20%",
                }}
              >
                Apply easily accesible deep learning models to your creative
                workflow.
              </p>
              <img src={perk5} style={{ width: "40px" }} />
              <h1 style={{ fontSize: "18px" }}>New Shaders</h1>
              <p
                style={{
                  color: "#989898",
                  paddingRight: "20%",
                }}
              >
                SketchtoRedner will evolve into an entire library of materials
                with everything from glass, metallics, and metals.
              </p>

              <div className="col s12 m12  l12 ">
                <Link to={"/signin"}>
                  <Button
                    className="get-started"
                    type="primary"
                    onClick={() => {
                      handlePioneerClick();
                    }}
                  >
                    Get started
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <h1
            style={{
              textAlign: "center",
              paddingLeft: "15%",
              paddingRight: "15%",
              paddingTop: "5%",
              color: "#e5e5e5",
              fontSize: "24px",
            }}
          >
            Render results in seconds
          </h1>
          <img
            style={{ width: "100%", paddingLeft: "15%", paddingRight: "15%" }}
            src={colormap}
          />
        </div>
        <div className="generator-inspiration">
          <h1 style={{ textAlign: "center", paddingTop: "20rem" }}>
            {" "}
            More generated inspiration
          </h1>
          <p
            style={{
              textAlign: "center",
              paddingBottom: "10rem",
            }}
          >
            A bigger pool of Generate synthesized images.
          </p>
          <img src={grid} />
          <br />
          <img src={example} />
          <h1
            data-aos="fade-up"
            style={{ textAlign: "center", paddingTop: "25rem" }}
          >
            Free updates
          </h1>
          <p data-aos="fade-up" style={{ textAlign: "center" }}>
            All on the web.
          </p>
          <img
            data-aos="fade-up"
            src={pc}
            style={{
              paddingBottom: "5%",
            }}
          />
          {/* center element */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              className="get-started"
              type="primary"
              onClick={() => {
                handlePioneerClick();
              }}
            >
              Get started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProductOverview;
